import { useMemo } from 'react';
import type { DatePickerAltLabels } from '@SBGSports/catapult-core';
import { useTranslations } from 'i18n';

export const usePickerLabels = (): DatePickerAltLabels => {
    const { __ } = useTranslations();

    return useMemo<DatePickerAltLabels>(
        () => ({
            todayButton: __('date_picker.today_button'),
            clearButton: __('date_picker.clear_button'),
            applyButton: __('date_picker.apply_button'),
            quickSelectHeading: __('date_picker.quick_select_heading'),
            rangeSeparator: __('date_picker.range_separator'),
            errorDateBeforeMin: (min: string) => __('date_picker.error_date_before_min', { min }),
            errorDateAfterMax: (max: string) => __('date_picker.error_date_after_max', { max }),
            errorEndBeforeStart: __('date_picker.error_end_before_start'),
            ariaPrevMonth: __('date_picker.aria_prev_month'),
            ariaNextMonth: __('date_picker.aria_next_month'),
            ariaPrevYear: __('date_picker.aria_prev_year'),
            ariaNextYear: __('date_picker.aria_next_year'),
            ariaPrevYearRange: __('date_picker.aria_prev_year_range'),
            ariaNextYearRange: __('date_picker.aria_next_year_range'),
            ariaPopoverDialog: __('date_picker.aria_popover_dialog'),
            ariaStartDate: __('date_picker.aria_start_date'),
            ariaEndDate: __('date_picker.aria_end_date'),
            ariaSwitchToMonths: (current: string) => __('date_picker.aria_switch_to_months', { current }),
            ariaSwitchToYears: (current: string) => __('date_picker.aria_switch_to_years', { current }),
            ariaMonthPicker: (year: number) => __('date_picker.aria_month_picker', { year: String(year) }),
            ariaYearPicker: (startYear: number, endYear: number) =>
                __('date_picker.aria_year_picker', { startYear: String(startYear), endYear: String(endYear) }),
            quickSelectToday: __('date_picker.quick_select_today'),
            quickSelectYesterday: __('date_picker.quick_select_yesterday'),
            quickSelectLast7Days: __('date_picker.quick_select_last_7_days'),
            quickSelectLast30Days: __('date_picker.quick_select_last_30_days'),
            quickSelectLast12Months: __('date_picker.quick_select_last_12_months'),
            quickSelectThisMonth: __('date_picker.quick_select_this_month'),
            quickSelectLastMonth: __('date_picker.quick_select_last_month'),
            quickSelectThisQuarter: __('date_picker.quick_select_this_quarter'),
            quickSelectYearToDate: __('date_picker.quick_select_year_to_date'),
        }),
        [__],
    );
};
